import { gql } from '@apollo/client';

export const suppliersQuery = gql`
  query {
    suppliers {
      personId
      supplierName
    }
  }
`;
